import { OfferType } from "@1games-ru/region-shared/dist/enums/offer/offer";
import useAppSelector from "@/core/helpers/useAppSelector";
import { OfferMode, offerModeSelector, offerTypeSelector } from "@/domains/offer/slice";
import useOfferCreatorSubscriber from "@/domains/offer/hooks/useOfferCreatorSubscriber";
import useOfferResolverSubscriber from "@/domains/offer/hooks/useOfferResolverSubscriber";
import OfferEstateBusinessCreatorContainer from "@/domains/offer/containers/estate/OfferEstateBusinessCreatorContainer";
import OfferEstateBusinessEmployeeCreatorContainer from "@/domains/offer/containers/estate/OfferEstateBusinessEmployeeCreatorContainer";
import OfferEstateBusinessEmployeeResolverContainer from "@/domains/offer/containers/estate/OfferEstateBusinessEmployeeResolverContainer";
import OfferEstateBusinessResolverContainer from "@/domains/offer/containers/estate/OfferEstateBusinessResolverContainer";
import OfferEstateCreatorContainer from "@/domains/offer/containers/estate/OfferEstateCreatorContainer";
import OfferEstateResolverContainer from "@/domains/offer/containers/estate/OfferEstateResolverContainer";
import OfferEstateTenantCreatorContainer from "@/domains/offer/containers/estate/OfferEstateTenantCreatorContainer";
import OfferEstateTenantResolverContainer from "@/domains/offer/containers/estate/OfferEstateTenantResolverContainer";
import OfferEstateVehicleCreatorContainer from "@/domains/offer/containers/estate/OfferEstateVehicleCreatorContainer";
import OfferEstateVehicleResolverContainer from "@/domains/offer/containers/estate/OfferEstateVehicleResolverContainer";

function OfferContainer() {
  const offerType = useAppSelector(offerTypeSelector);
  const offerMode = useAppSelector(offerModeSelector);
  useOfferCreatorSubscriber();
  useOfferResolverSubscriber();

  const isShow = (type: OfferType, mode: OfferMode) => offerMode === mode && type === offerType;

  return (
    <>
      {/* Недвижимость */}
      {isShow(OfferType.EstateTrade, OfferMode.Creator) && <OfferEstateCreatorContainer isShow />}
      {isShow(OfferType.EstateTrade, OfferMode.Resolver) && <OfferEstateResolverContainer isShow />}

      {/* Прописка */}
      {isShow(OfferType.EstateInvite, OfferMode.Creator) && (
        <OfferEstateTenantCreatorContainer isShow />
      )}
      {isShow(OfferType.EstateInvite, OfferMode.Resolver) && (
        <OfferEstateTenantResolverContainer isShow />
      )}

      {/* Бизнес */}
      {isShow(OfferType.BusinessTrade, OfferMode.Creator) && (
        <OfferEstateBusinessCreatorContainer isShow />
      )}
      {isShow(OfferType.BusinessTrade, OfferMode.Resolver) && (
        <OfferEstateBusinessResolverContainer isShow />
      )}

      {/* Трудоустроить в бизнес */}
      {isShow(OfferType.BusinessInvite, OfferMode.Creator) && (
        <OfferEstateBusinessEmployeeCreatorContainer isShow />
      )}
      {isShow(OfferType.BusinessInvite, OfferMode.Resolver) && (
        <OfferEstateBusinessEmployeeResolverContainer isShow />
      )}

      {/* Автомобили */}
      {isShow(OfferType.VehicleTrade, OfferMode.Creator) && (
        <OfferEstateVehicleCreatorContainer isShow />
      )}
      {isShow(OfferType.VehicleTrade, OfferMode.Resolver) && (
        <OfferEstateVehicleResolverContainer isShow />
      )}

      {/* Документы */}
      {isShow(OfferType.ShowDocuments, OfferMode.Creator) && (
        <OfferEstateVehicleCreatorContainer isShow />
      )}
      {isShow(OfferType.ShowDocuments, OfferMode.Resolver) && (
        <OfferEstateVehicleResolverContainer isShow />
      )}
    </>
  );
}

export default OfferContainer;
